import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {PoliticasPerfilesRiesgo} from '../_models/politicas-perfiles-riesgo';

@Injectable({
  providedIn: 'root'
})
export class PoliticaPerfilesRiesgosService {

  private rutServicio = AppSettings.rutServiciosPOLITICA + '/api/politicasPerfilesRiesgos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) { }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PoliticasPerfilesRiesgo[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PoliticasPerfilesRiesgo[] ) );
  }

  listadoPorPolitica( idPolitica: string ) {
    return this.httClient.get( this.rutServicio + '/politica/' + idPolitica ).pipe( map( res => res as PoliticasPerfilesRiesgo[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as PoliticasPerfilesRiesgo ) );
  }

  crear( regCrear: PoliticasPerfilesRiesgo ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PoliticasPerfilesRiesgo ) );
  }

  actualizar( regActualizar: PoliticasPerfilesRiesgo ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: PoliticasPerfilesRiesgo[] ) {
    regActualizar.map( ( s: PoliticasPerfilesRiesgo ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar  ).pipe( map( res => res as any ) );
  }
}
